import React, { useEffect, useState, useRef } from 'react';
import { Redirect, Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import PageWrapper from '../PageWrapper';
import GenericAnalytics from './GenericAnalytics';
import CompetencyAnalytics from './CompetencyAnalytics';
import SocialAnalytics from './SocialAnalytics';
import SubNavbar from "../../components/Navbar/SubNavbar";
import { connect, useDispatch, useSelector } from 'react-redux';
import { getAnalyticsModuleCardDetails } from '../../redux/actions/analyticsActions';
const AnalyticsPages = (props) => {
    const { path } = useRouteMatch();
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getAnalyticsModuleCardDetails())
    });
    return (
        <PageWrapper>
            <div className='border20px shadow-sm md:mb-6 mb-3'>
                <SubNavbar
                    menuLinks={[
                        { title: "Competency Analytics", url: `${path}`, count: null },
                        { title: "Generic Analytics", url: `${path}/generic`, count: null },
                        { title: 'Social Analytics', url: `${path}/social`, count: null },
                    ]}
                />
                <Switch>
                    <Route exact path={path} component={CompetencyAnalytics} />
                    <Route path={`${path}/generic`} component={GenericAnalytics} />
                    <Route path={`${path}/social`} component={SocialAnalytics} />
                    <Redirect
                        to={{
                            pathname: "/page-not-found",
                            state: { error: true },
                        }}
                    />
                </Switch>
            </div>
        </PageWrapper>
    )
}

export default AnalyticsPages;